<template>
  <v-dialog max-width="800" v-model="dialog">
    <v-card>
      <v-btn absolute style="right: 0" icon @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-card-text>
        <div class="d-flex align-center justify-space-between pb-4 pt-7">
          <v-card-title class="pa-0"
            >{{ $t("historyContractCode", { code: contract.code }) }}
          </v-card-title>
          <!--          <v-btn-->
          <!--            color="primary"-->
          <!--            :to="{ name: 'contract-history', query: { code: contract.code } }"-->
          <!--          >-->
          <!--            {{ $t("viewContractHistory") }}-->
          <!--          </v-btn>-->
        </div>
        <table-with-children
          :items="histories?.data?.items"
          :headers="headers"
          :loading="loading"
        >
          <template #item.state="{ item: { state } }">
            {{ state }}
          </template>
          <template #item.action="{ item }">
            <v-btn
              :to="{
                name: 'contract-history-item',
                query: { itemNumb: item.numb, code: contract.code },
              }"
              class="new_style"
            >
              <vue-icon icon="newTimeIcon"></vue-icon>
            </v-btn>
          </template>
        </table-with-children>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TableWithChildren from "@/components/table-with-children/tableWithChildren";

export default {
  name: "ContractHistoryDialog",
  components: { TableWithChildren },
  data() {
    return {
      dialog: false,
      histories: [],
      contract: {
        code: null,
      },
      loading: false,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.histories = [];
        this.contract = {
          code: null,
        };
      }
    },
  },
  methods: {
    async open(id) {
      this.dialog = true;
      this.loading = true;
      try {
        const {
          data: { data, code },
        } = await this.$http.get("/contract/office/node", {
          params: { id },
        });
        this.contract = {
          code,
          id,
        };
        this.histories = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("numberPositionInContract"),
          value: "numb",
        },
        {
          text: this.$t("productName"),
          value: "productName",
        },
        {
          text: this.$t("count"),
          value: "count",
        },

        {
          text: this.$t("state"),
          value: "state",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
  },
};
</script>
